import React from "react";
import { BiInfoCircle } from "react-icons/bi";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { HiOutlineTicket } from "react-icons/hi";
import HtmlTooltip from "@mui/material/Tooltip";
import { Assort } from "../../../models/Assort";
import { useTranslation } from "react-i18next";
import AssortLineQntButtons from "./features/AssortLineQntButtons";
import AssortLineSelectorButtons from "./features/AssortLineSelectorButtons";
import { BasketItem } from "../../../models/BasketItem";
import getId from "../../../../utils/getId";
interface IProps {
  item: Assort;
  onAddLine: (assort: Assort, qnt: number) => void;
  limitToOneItem: boolean;
  lines: BasketItem[];
  onSelectLine: (assort: Assort) => void;
}

const AssortLine: React.FC<IProps> = ({ item, onAddLine, limitToOneItem, lines, onSelectLine }: IProps) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();

  const isSelected = (ids: string) => {
    return lines.filter((item: BasketItem) => item.assortIds === ids).length > 0;
  };

  return (
    <>
      <div className="ticket-line-left flex-start-center">
        <div className="flex-between-center">
          <HiOutlineTicket className="ticket-line-icon" />
          <b>{item.name}</b>
        </div>

        {isDesktop ? (
          <HtmlTooltip
            placement="right"
            title={
              <>
                <article
                  className="tooltip-description"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></article>
              </>
            }
          >
            <b>
              <BiInfoCircle className="tooltip-icon" />
            </b>
          </HtmlTooltip>
        ) : (
          <b>
            <BiInfoCircle className="tooltip-icon" />
          </b>
        )}
      </div>

      <div className="ticket-line-right flex-end-center">
        <b className="price">
          {item.price.toFixed(2)} {t("zl")}
        </b>

        <div className="qnt flex-center-center">
          {limitToOneItem ? (
            <AssortLineSelectorButtons isSelected={isSelected(getId(item))} onSelect={() => onSelectLine(item)} />
          ) : (
            <AssortLineQntButtons onAddLine={onAddLine} item={item} />
          )}
        </div>
      </div>
    </>
  );
};

export default AssortLine;
